import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const ivPlotsSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 25.9256L20.2056 15.777L26.3813 21.6059L37.75 10.25M37.75 10.25C37.75 10.25 37.5 10 37 10C36.5 10 30.1495 10 30.1495 10M37.75 10.25C37.75 10.25 38 10.5 38 11C38 11.5 38 18.0149 38 18.0149M38 22.2305L27.6374 32.6914L21.514 26.6543L10.25 37.75M17.7981 38C17.7981 38 11.5 38 11 38C10.5 38 10.25 37.75 10.25 37.75M10 30.1933C10 30.1933 10 36.5 10 37C10 37.5 10.25 37.75 10.25 37.75"
            stroke="currentColor"/>
    </svg>


)

const IvPlots: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ivPlotsSvg}
    </SvgIcon>
)

export default IvPlots